import moment from 'moment'

let timerfilter = (options) =>{
    return moment(options).format('YYYY-MM-DD HH:mm')
}

//console.log(timerfilter('2023-08-16T12:40:27.805Z'))

export {
    timerfilter
}